/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { allServiceLinkedToAuthSupport } from '../fn/subscriptions/all-service-linked-to-auth-support';
import { AllServiceLinkedToAuthSupport$Params } from '../fn/subscriptions/all-service-linked-to-auth-support';
import { createSubscriptionSubService } from '../fn/sub-services/create-subscription-sub-service';
import { CreateSubscriptionSubService$Params } from '../fn/sub-services/create-subscription-sub-service';
import { Error } from '../models/error';
import { getAllSubscriptionSubServices } from '../fn/sub-services/get-all-subscription-sub-services';
import { GetAllSubscriptionSubServices$Params } from '../fn/sub-services/get-all-subscription-sub-services';
import { getAllSubscriptionSubServicesSummaries } from '../fn/sub-services/get-all-subscription-sub-services-summaries';
import { GetAllSubscriptionSubServicesSummaries$Params } from '../fn/sub-services/get-all-subscription-sub-services-summaries';
import { getSubscriptionSubService } from '../fn/sub-services/get-subscription-sub-service';
import { GetSubscriptionSubService$Params } from '../fn/sub-services/get-subscription-sub-service';
import { getSubService } from '../fn/sub-services/get-sub-service';
import { GetSubService$Params } from '../fn/sub-services/get-sub-service';
import { searchSubServices } from '../fn/sub-services/search-sub-services';
import { SearchSubServices$Params } from '../fn/sub-services/search-sub-services';
import { setSubscriptionSubServiceActiveState } from '../fn/sub-services/set-subscription-sub-service-active-state';
import { SetSubscriptionSubServiceActiveState$Params } from '../fn/sub-services/set-subscription-sub-service-active-state';
import { SubscriptionSubService } from '../models/subscription-sub-service';
import { SubscriptionSubServiceList } from '../models/subscription-sub-service-list';
import { SubscriptionSubServicePagedList } from '../models/subscription-sub-service-paged-list';
import { SubscriptionSubServiceSummaryList } from '../models/subscription-sub-service-summary-list';
import { updateSubscriptionSubService } from '../fn/sub-services/update-subscription-sub-service';
import { UpdateSubscriptionSubService$Params } from '../fn/sub-services/update-subscription-sub-service';


/**
 * All about the subscriptions sub services
 */
@Injectable({ providedIn: 'root' })
export class SubServicesService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `allServiceLinkedToAuthSupport()` */
  static readonly AllServiceLinkedToAuthSupportPath = '/subscriptions/{uid}/sub-service/linked';

  /**
   * All service linked to an auth support.
   *
   * All service linked to an auth support
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `allServiceLinkedToAuthSupport()` instead.
   *
   * This method doesn't expect any request body.
   */
  allServiceLinkedToAuthSupport$Response(params: AllServiceLinkedToAuthSupport$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionSubServiceList>> {
    return allServiceLinkedToAuthSupport(this.http, this.rootUrl, params, context);
  }

  /**
   * All service linked to an auth support.
   *
   * All service linked to an auth support
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `allServiceLinkedToAuthSupport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  allServiceLinkedToAuthSupport(params: AllServiceLinkedToAuthSupport$Params, context?: HttpContext): Observable<SubscriptionSubServiceList> {
    return this.allServiceLinkedToAuthSupport$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionSubServiceList>): SubscriptionSubServiceList => r.body)
    );
  }

  /** Path part for operation `getAllSubscriptionSubServices()` */
  static readonly GetAllSubscriptionSubServicesPath = '/subscriptions/{uid}/sub-service';

  /**
   * Get all sub services of a subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllSubscriptionSubServices()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSubscriptionSubServices$Response(params: GetAllSubscriptionSubServices$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionSubServiceList>> {
    return getAllSubscriptionSubServices(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all sub services of a subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllSubscriptionSubServices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSubscriptionSubServices(params: GetAllSubscriptionSubServices$Params, context?: HttpContext): Observable<SubscriptionSubServiceList> {
    return this.getAllSubscriptionSubServices$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionSubServiceList>): SubscriptionSubServiceList => r.body)
    );
  }

  /** Path part for operation `createSubscriptionSubService()` */
  static readonly CreateSubscriptionSubServicePath = '/subscriptions/{uid}/sub-service';

  /**
   * Create a subscription sub service.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSubscriptionSubService()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSubscriptionSubService$Response(params: CreateSubscriptionSubService$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createSubscriptionSubService(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a subscription sub service.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSubscriptionSubService$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSubscriptionSubService(params: CreateSubscriptionSubService$Params, context?: HttpContext): Observable<void> {
    return this.createSubscriptionSubService$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAllSubscriptionSubServicesSummaries()` */
  static readonly GetAllSubscriptionSubServicesSummariesPath = '/subscriptions/{uid}/sub-service/summary';

  /**
   * Get all sub services summaries of a subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllSubscriptionSubServicesSummaries()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSubscriptionSubServicesSummaries$Response(params: GetAllSubscriptionSubServicesSummaries$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionSubServiceSummaryList>> {
    return getAllSubscriptionSubServicesSummaries(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all sub services summaries of a subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllSubscriptionSubServicesSummaries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSubscriptionSubServicesSummaries(params: GetAllSubscriptionSubServicesSummaries$Params, context?: HttpContext): Observable<SubscriptionSubServiceSummaryList> {
    return this.getAllSubscriptionSubServicesSummaries$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionSubServiceSummaryList>): SubscriptionSubServiceSummaryList => r.body)
    );
  }

  /** Path part for operation `getSubscriptionSubService()` */
  static readonly GetSubscriptionSubServicePath = '/subscriptions/{uid}/sub-service/{serviceUid}';

  /**
   * Get a subscription sub service.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionSubService()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionSubService$Response(params: GetSubscriptionSubService$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionSubService>> {
    return getSubscriptionSubService(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a subscription sub service.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionSubService$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionSubService(params: GetSubscriptionSubService$Params, context?: HttpContext): Observable<SubscriptionSubService> {
    return this.getSubscriptionSubService$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionSubService>): SubscriptionSubService => r.body)
    );
  }

  /** Path part for operation `updateSubscriptionSubService()` */
  static readonly UpdateSubscriptionSubServicePath = '/subscriptions/{uid}/sub-service/{serviceUid}';

  /**
   * Update a subscription sub service.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSubscriptionSubService()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSubscriptionSubService$Response(params: UpdateSubscriptionSubService$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateSubscriptionSubService(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a subscription sub service.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSubscriptionSubService$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSubscriptionSubService(params: UpdateSubscriptionSubService$Params, context?: HttpContext): Observable<void> {
    return this.updateSubscriptionSubService$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getSubService()` */
  static readonly GetSubServicePath = '/sub-service/{uid}';

  /**
   * Get a sub service.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubService()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubService$Response(params: GetSubService$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionSubService>> {
    return getSubService(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a sub service.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubService$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubService(params: GetSubService$Params, context?: HttpContext): Observable<SubscriptionSubService> {
    return this.getSubService$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionSubService>): SubscriptionSubService => r.body)
    );
  }

  /** Path part for operation `setSubscriptionSubServiceActiveState()` */
  static readonly SetSubscriptionSubServiceActiveStatePath = '/subscriptions/{uid}/sub-service/{serviceUid}/activation';

  /**
   * Change a subscription sub service active state.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setSubscriptionSubServiceActiveState()` instead.
   *
   * This method doesn't expect any request body.
   */
  setSubscriptionSubServiceActiveState$Response(params: SetSubscriptionSubServiceActiveState$Params, context?: HttpContext): Observable<StrictHttpResponse<Error>> {
    return setSubscriptionSubServiceActiveState(this.http, this.rootUrl, params, context);
  }

  /**
   * Change a subscription sub service active state.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setSubscriptionSubServiceActiveState$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  setSubscriptionSubServiceActiveState(params: SetSubscriptionSubServiceActiveState$Params, context?: HttpContext): Observable<Error> {
    return this.setSubscriptionSubServiceActiveState$Response(params, context).pipe(
      map((r: StrictHttpResponse<Error>): Error => r.body)
    );
  }

  /** Path part for operation `searchSubServices()` */
  static readonly SearchSubServicesPath = '/sub-service/search';

  /**
   * Search sub-services.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchSubServices()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchSubServices$Response(params?: SearchSubServices$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionSubServicePagedList>> {
    return searchSubServices(this.http, this.rootUrl, params, context);
  }

  /**
   * Search sub-services.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchSubServices$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchSubServices(params?: SearchSubServices$Params, context?: HttpContext): Observable<SubscriptionSubServicePagedList> {
    return this.searchSubServices$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionSubServicePagedList>): SubscriptionSubServicePagedList => r.body)
    );
  }

}
